module.exports = __webpack_public_path__ + "img/Entsorgungsstelle.81047160.svg";